import { StyleSheet } from 'react-native'

import { Box, useTheme } from '../theme/restyle'
import { FigmaAlertCircleIcon } from './FigmaSystemIcons'

// Shared status circle (Figma: Fun Mobile `status-icon`) for the geo-blocked
// and unavailable/error screens.
export function StatusIcon() {
  const theme = useTheme()
  return (
    <Box
      borderRadius="rounded"
      alignItems="center"
      justifyContent="center"
      style={[styles.circle, { backgroundColor: theme.background.secondary }]}
    >
      <FigmaAlertCircleIcon
        size={20}
        color={theme.content.button.icon.default}
      />
    </Box>
  )
}

const styles = StyleSheet.create({
  circle: { width: 48, height: 48 },
})
